import { config } from 'src/config/config';
import i18n from 'src/config/i18n';
import { MessageType, renderMessage } from '../ds';

type RenderSpecificMessageTypeFunction = (message: string) => void;

const translate = (message: string) =>
    i18n.t(message, { maxAvatarSize: config.maxAvatarSizeInBytes / 1000000 });

export class ToastNotificationsService {
    private renderMessage = (type: MessageType): RenderSpecificMessageTypeFunction => message => {
        const translatedMessage = translate(message);

        const duration = translatedMessage.length > 60 ? 10 : 4;

        renderMessage({ content: translatedMessage, type, duration });
    };

    public renderWarningToast: RenderSpecificMessageTypeFunction = this.renderMessage('warning');

    public renderErrorToast: RenderSpecificMessageTypeFunction = this.renderMessage('error');

    public renderSuccessToast: RenderSpecificMessageTypeFunction = this.renderMessage('success');

    public renderInfoToast: RenderSpecificMessageTypeFunction = this.renderMessage('info');
}
